<div class="recorder_modal user-action_modal">
  <form [formGroup]="form" novalidate>
    <p class="recorder_modal_title">Edit Payment Config</p>

    <!-- Number of Keywords -->
    <label class="custom-input_field_withoutIcon">
      <span class="custom-input_field-label">
        {{ "words.maximum_number_of_keywords" | translate }}
      </span>
      <input
        class="custom-input_field"
        matInput
        #organicKeywordsNum
        formControlName="organicKeywordsNum"
        type="number"
        min="1"
      />
    </label>

    <!-- Price -->
    <label class="custom-input_field_withoutIcon">
      <span class="custom-input_field-label">
        {{ "words.price" | translate }}
        <ng-container *ngIf="selectedCurrency && selectedCurrency != ''">
          ({{ selectedCurrency }})
        </ng-container>
      </span>
      <input
        class="custom-input_field"
        matInput
        #price
        formControlName="price"
        type="number"
        min="1"
      />
    </label>

    <!-- Currency -->
    <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label"> Currency </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select #currency formControlName="currency" value="USD">
            <mat-option *ngFor="let l of currencyList" [value]="l.code">
              {{ l.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Bank -->
    <div class="custom_option_picker_with_absolute_label" *ngIf="!isWhiteLabel">
      <span class="custom_option_picker-label"> Bank </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select
            #stripeAccount
            formControlName="stripeAccount"
            value="USD"
          >
            <mat-option *ngFor="let l of banksList" [value]="l.stripeAccount">
              {{ l.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Interval -->
    <div class="custom_option_picker_with_absolute_label">
      <span class="custom_option_picker-label">
        {{ "words.billing_interval" | translate }}
      </span>
      <div class="custom_option_picker">
        <mat-form-field class="full-wid">
          <mat-select
            #billingInterval
            formControlName="billingInterval"
            value="monthly"
          >
            <mat-option *ngFor="let l of billingIntervalList" [value]="l.value">
              {{ l.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Packages -->
    <div
      class="packages-container"
      [ngClass]="{
        'packages-container-hidden': !form.get('displayPackages')?.value
      }"
    >
      <div class="packages-container-header">
        <p>Include Additional Packages</p>
        <mat-slide-toggle
          class="packages-container-toggle"
          formControlName="displayPackages"
          (change)="getAdditionalPackages($event)"
        >
        </mat-slide-toggle>
      </div>
      <div class="packages-container-content">
        <div class="package-item">
          <!-- Number of Keywords -->
          <label class="custom-input_field_withoutIcon">
            <span class="custom-input_field-label">
              {{ "words.maximum_number_of_keywords" | translate }}
            </span>
            <input
              class="custom-input_field"
              matInput
              #organicKeywordsNum
              formControlName="package1Keywords"
              type="number"
            />
          </label>

          <!-- Price -->
          <label class="custom-input_field_withoutIcon">
            <span class="custom-input_field-label">
              {{ "words.price" | translate }}
              <ng-container *ngIf="selectedCurrency && selectedCurrency != ''">
                ({{ selectedCurrency }})
              </ng-container>
            </span>
            <input
              class="custom-input_field"
              matInput
              #price
              formControlName="package1Price"
              type="number"
            />
          </label>
        </div>
        <div class="package-item">
          <!-- Number of Keywords -->
          <label class="custom-input_field_withoutIcon">
            <span class="custom-input_field-label">
              {{ "words.maximum_number_of_keywords" | translate }}
            </span>
            <input
              class="custom-input_field"
              matInput
              #organicKeywordsNum
              formControlName="package2Keywords"
              type="number"
            />
          </label>

          <!-- Price -->
          <label class="custom-input_field_withoutIcon">
            <span class="custom-input_field-label">
              {{ "words.price" | translate }}
              <ng-container *ngIf="selectedCurrency && selectedCurrency != ''">
                ({{ selectedCurrency }})
              </ng-container>
            </span>
            <input
              class="custom-input_field"
              matInput
              #price
              formControlName="package2Price"
              type="number"
            />
          </label>
        </div>
      </div>
    </div>
  </form>

  <div class="button_container">
    <button
      mat-raised-button
      (click)="clearForm()"
      style="margin-right: auto"
      *ngIf="data"
      [disabled]="isClearPressed"
    >
      <!-- {{ "words.clear" | translate }} -->
      Clear Config
    </button>
    <button mat-raised-button (click)="dialogRef.close()">
      {{ "words.cancel" | translate }}
    </button>
    <button
      mat-raised-button
      class="primary"
      (click)="editConfig()"
      [disabled]="!isFormValid(true)"
    >
      {{
        !isProcessing
          ? ("words.save" | translate)
          : ("words.processing" | translate) + "..."
      }}
    </button>
  </div>
</div>
